<script lang="ts">
  import WorkOrderContactTags from "../../../../../../../../../_shared/_modules/work-order-contact-tags"
  import { formatPropertyCustomerRole } from "../../../../../../../../../_shared/_logic/customer-roles"
  import {
    buildContactTag,
    type ContactPointLike,
  } from "../../../../../../../../../_shared/_logic/contact-quality-tags"
  import {
    cleanText,
    buildInboxContactSubLabel,
    emptyLabel,
    extractEmail,
    extractPhone,
  } from "../../_logic/cells-presentation"

  let {
    label = "",
    roleLabel = "",
    email = "",
    phone = "",
    unitLabel = "",
    contactPoints: suppliedContactPoints,
    disabled = false,
  }: {
    label?: string
    roleLabel?: string
    email?: string
    phone?: string
    unitLabel?: string
    contactPoints?: ContactPointLike[]
    disabled?: boolean
  } = $props()

  const resolvedLabel = $derived(cleanText(label) || "Unbekannter Ansprechpartner")
  const resolvedEmail = $derived(cleanText(email) || extractEmail(label))
  const resolvedPhone = $derived(cleanText(phone) || extractPhone(label))
  const resolvedRoleLabel = $derived(roleLabel ? formatPropertyCustomerRole(roleLabel) : null)
  const visibleUnitLabel = $derived.by(() => {
    const text = cleanText(unitLabel)

    if (!text) return null

    return text.toLocaleLowerCase("de-DE").startsWith("zuordnung:") ? null : text
  })
  const contactPoints = $derived.by(() => {
    if (suppliedContactPoints) return suppliedContactPoints

    const points: ContactPointLike[] = []

    if (resolvedEmail) {
      points.push({
        id: `${resolvedLabel}:email`,
        kind: "EMAIL",
        value: resolvedEmail,
        lifecycle_status: "ACTIVE",
        source: "INBOUND_LEARNED",
        is_verified: false,
      })
    }

    return points
  })
  const tag = $derived.by(() => {
    const contactTag = buildContactTag({
      id: resolvedLabel,
      fallbackLabel: resolvedLabel,
      contactPoints,
      roleLabel: resolvedRoleLabel,
      unitLabel: visibleUnitLabel,
    })

    return {
      ...contactTag,
      subLabel: buildInboxContactSubLabel(resolvedRoleLabel, resolvedPhone),
    }
  })
</script>

{#if cleanText(label)}
  <span class="inbox-contact" class:disabled>
    <span class="inbox-cell-tag">
      <WorkOrderContactTags tags={[tag]} {emptyLabel} splitRoleAndName={true} />
    </span>
  </span>
{:else}
  <span class="inbox-cell-empty" class:disabled aria-label="Kein Ansprechpartner">
    {emptyLabel}
  </span>
{/if}

<style>
  .inbox-contact {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.2rem;
    max-width: 100%;
  }

  .inbox-cell-tag {
    display: inline-flex;
    max-width: 100%;
  }

  .inbox-cell-empty {
    color: var(--text-invers-100);
    font-weight: 700;
  }

  .disabled {
    opacity: 0.54;
  }
</style>
